import { render, staticRenderFns } from "./talent_add_upload.vue?vue&type=template&id=03a15946&scoped=true"
import script from "./talent_add_upload.vue?vue&type=script&lang=js"
export * from "./talent_add_upload.vue?vue&type=script&lang=js"
import style0 from "./talent_add_upload.vue?vue&type=style&index=0&id=03a15946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a15946",
  null
  
)

export default component.exports